
import { Vue, Component } from 'vue-property-decorator';
import LogoutCard from '@/features/auth/components/logout/index.vue';
import NavLogo from '@/features/common/components/navbar/NavLogo.vue';

@Component({
  components: {
    LogoutCard,
    NavLogo,
  },
})
export default class Logout extends Vue {}
